var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmazonqdeveloper = function SvgAmazonqdeveloper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.14 115.53"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "amazonqdeveloper_svg__a",
    x1: -228.54,
    x2: -246.11,
    y1: 480.48,
    y2: 446.65,
    gradientTransform: "matrix(2.16 0 0 -2.16 569.95 1056)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2fabff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5570ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#7b36ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6a2cdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5921b8"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.26
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.82 2.58c-2.78-1.49-7.28-1.48-10.05.02L6.48 25.03c-2.77 1.5-5.02 5.29-5.02 8.44v46.67c0 3.15 2.21 7 4.94 8.59l41.45 24.15c2.72 1.59 7.16 1.61 9.9.05l41.96-23.9c2.74-1.56 4.96-5.39 4.96-8.54v-47c0-3.15-2.25-6.92-5.03-8.42z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "2.93px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.78 7.84a14.06 14.06 0 0 0-14.08 0L14.44 26.47a14.09 14.09 0 0 0-7.04 12.2v37.26c0 5.03 2.68 9.68 7.04 12.2l32.26 18.63c4.36 2.52 9.73 2.52 14.08 0l32.26-18.63c4.36-2.52 7.04-7.17 7.04-12.2V38.67c0-5.03-2.68-9.68-7.04-12.2z",
    style: {
      fill: "url(#amazonqdeveloper_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.26 21.44 25.38 34.65a11.25 11.25 0 0 0-5.63 9.76v26.43c0 4.03 2.15 7.74 5.63 9.76l22.88 13.21c3.49 2.01 7.78 2.01 11.27 0L82.41 80.6a11.25 11.25 0 0 0 5.63-9.76V44.41c0-4.03-2.15-7.74-5.63-9.76L59.53 21.44a11.29 11.29 0 0 0-11.27 0m3.52 6.26a5.61 5.61 0 0 1 5.63 0l21.81 12.59a5.64 5.64 0 0 1 2.82 4.88v25.19c0 2.01-1.07 3.87-2.82 4.88L57.41 87.83a5.61 5.61 0 0 1-5.63 0L29.97 75.24a5.64 5.64 0 0 1-2.82-4.88V45.17c0-2.01 1.07-3.87 2.82-4.88zm2.47 23.62a1.42 1.42 0 0 0-1.41 0l-4.69 2.71c-.44.25-.7.72-.7 1.22v5.42c0 .5.27.97.7 1.22l4.69 2.71c.44.25.97.25 1.41 0l4.69-2.71c.44-.25.7-.72.7-1.22v-5.42c0-.5-.27-.97-.7-1.22zm3.52 5.23-2.82 5.63 26.76 15.49 2.82-5.63z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgAmazonqdeveloper;